import React, { useEffect } from 'react';
import useFormRequiredStore from './FormConditionStores/useFormRequiredStore';
import ItemStatementCondition from './FormConditionComponents/ItemStatementRequired';

function FormConditional({ required, availablePlaceholders }) {
  useEffect(() => {
    if (required && required.Statement) {
      useFormRequiredStore.getState().setStatement(required);
      useFormRequiredStore.getState().setFormConditional(required);
    } else {
      useFormRequiredStore.getState().initialiseEmpty();
    }
  }, []);

  const { Condition } = useFormRequiredStore((s) => s.Statement.Statement.content);
  const AnswerList = useFormRequiredStore((s) => s.AnswerList);

  return (
    <div
      style={{
        boxShadow: '0px 2px 4px var(--mui-palette-action-focus)',
        padding: '15px 15px 30px',
        margin: '15px 0',
      }}
    >
      {Condition &&
        Condition.map((condition, index) => (
          <ItemStatementCondition
            condition={condition}
            indexStatement={index}
            key={index}
            AnswerList={AnswerList[index]}
          />
        ))}
    </div>
  );
}
export default FormConditional;
